const relacao_de_aluno_sem_fase_origem = [
  {
    path: "/relacao-de-aluno-sem-fase-origem",
    redirect: "/relacao-de-aluno-sem-fase-origem",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/relacao-de-aluno-sem-fase-origem",
        name: "relacao-de-aluno-sem-fase-origem",
        component: () =>
          import(
            "@/views/RelacaoDeAlunoSemFaseOrigem/RelacaoDeAlunoSemFaseOrigem.vue"
          ),
      },
    ],
  },
];

export { relacao_de_aluno_sem_fase_origem };
